import React from 'react'
import { GiftListHeader, Toggle, Title } from '../styles/giftList'
import ExpandIcon from '../assets/icons/expand.svg'

export default ({ title, collapsed, onToggle }) =>
  <GiftListHeader
    cursor={collapsed == null ? 'default' : 'pointer'}
    onClick={onToggle}
  >
    <Title>{title}</Title>
    {collapsed != null &&
      <Toggle src={ExpandIcon}
        alt=""
        collapsed={collapsed}
      />
    }
  </GiftListHeader>
